var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6053 14.2473L11.8936 1.90935C10.8152 0.0939227 8.18648 0.0915106 7.10667 1.90935L0.395221 14.2473C-0.70715 16.1024 0.627489 18.4515 2.78811 18.4515H16.2119C18.3707 18.4515 19.7077 16.1043 18.6053 14.2473ZM9.50012 16.2249C8.8864 16.2249 8.38684 15.7254 8.38684 15.1116C8.38684 14.4979 8.8864 13.9984 9.50012 13.9984C10.1138 13.9984 10.6134 14.4979 10.6134 15.1116C10.6134 15.7254 10.1138 16.2249 9.50012 16.2249ZM10.6134 11.7718C10.6134 12.3855 10.1138 12.8851 9.50012 12.8851C8.8864 12.8851 8.38684 12.3855 8.38684 11.7718V6.20539C8.38684 5.59168 8.8864 5.09211 9.50012 5.09211C10.1138 5.09211 10.6134 5.59168 10.6134 6.20539V11.7718Z",
    fill: "#2E89E2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning_icon.ee456f08e8c1723e333077d48af4042e.svg";
export { ForwardRef as ReactComponent };